import { useState } from 'react';
import { X } from 'lucide-react';

interface AvisoSaldoBaixoProps {
  saldo: number;
  /** Quem libera os créditos: "à sua revenda" ou "ao seu administrador" */
  destinatario: string;
  /** `silenciar` = o usuário marcou "Não mostrar mais este aviso" */
  aoFechar: (silenciar: boolean) => void;
}

// Aviso de créditos baixos (saldo entre 1 e LIMITE_AVISO_SALDO). Mesmo visual do modal de
// saldo insuficiente da tela de impressão.
export function AvisoSaldoBaixo({ saldo, destinatario, aoFechar }: AvisoSaldoBaixoProps) {
  const [naoMostrarMais, setNaoMostrarMais] = useState(false);

  return (
    <div className="fixed inset-0 z-[9999] overflow-y-auto">
      <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" />

      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative bg-white rounded-lg shadow-xl max-w-lg w-full p-6">
          <button
            onClick={() => aoFechar(false)}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-500"
            aria-label="Fechar"
          >
            <X size={20} />
          </button>

          <h3 className="text-lg font-semibold text-gray-900 mb-4">
            Seus créditos estão baixos
          </h3>

          <div className="bg-amber-50 border-l-4 border-amber-400 p-3 text-sm text-amber-800 space-y-2">
            <p>
              Você tem <strong>{saldo} {saldo === 1 ? 'crédito restante' : 'créditos restantes'}</strong>.
            </p>
            <p>
              Solicite mais créditos {destinatario} e evite ficar sem saldo para impressões.
            </p>
          </div>

          <div className="mt-6 flex items-center justify-between gap-4">
            <label className="flex items-center gap-2 text-sm text-gray-600 cursor-pointer select-none">
              <input
                type="checkbox"
                checked={naoMostrarMais}
                onChange={(e) => setNaoMostrarMais(e.target.checked)}
                className="h-4 w-4 rounded border-gray-300"
              />
              Não mostrar mais este aviso
            </label>
            <button
              onClick={() => aoFechar(naoMostrarMais)}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors font-medium"
            >
              Entendi
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
